module.exports = __webpack_public_path__ + "img/eye-active.7d8d9621.svg";